// Extracts a generator run id from a 3D Studio detail URL.
//
// Current contract — kept in sync with the id fallback of
// Pods/ThreeDStudio/Hooks/buildSharedRunPathname.js:
//   /ai-3d-model-generator/3d-models/<slug>-<numericRunId>
//
// Only that fallback shape carries a recoverable id. Runs with a persisted
// `Generator::Run#slug` (<title>-<random token>) normally yield null here, which is fine:
// they are resolved by slug through the community-models endpoint.
//
// The title part is restricted to [a-z0-9-] — everything slugifyTitle can emit — which
// narrows but does not eliminate overlap with persisted slugs: `urlsafe_base64` can emit an
// all-lowercase token ending in `-<digits>` (e.g. `battle-mech-ab-cd1234` -> 1234). Callers
// must therefore treat a parsed id as advisory, never as proof the URL is the id fallback.
//
// Returns the numeric id, or null when the path does not point at a known
// shared-run detail URL. Under the URL-is-source-of-truth contract, callers
// use null to mean "no model is open" for /ai, gallery, and unrelated paths.
//
// If the URL scheme changes — e.g. to a pure slug without the trailing id —
// update this parser AND its tests. Without a recoverable id in the URL,
// client-side back/forward navigation cannot rehydrate the shared run; the
// remediation in that case is a server lookup (slug -> run id) reached via
// a new API endpoint. Keep this comment honest if you change the format.
const SHARED_RUN_PATHNAME_REGEX = /^\/ai-3d-model-generator\/3d-models\/(?:[a-z0-9-]*-)?(\d+)\/?$/

export const parseRunIdFromPathname = (pathname) => {
  if (typeof pathname !== 'string') {
    return null
  }
  const match = pathname.match(SHARED_RUN_PATHNAME_REGEX)
  if (!match) {
    return null
  }
  const parsed = Number(match[1])
  return Number.isFinite(parsed) ? parsed : null
}

export default parseRunIdFromPathname
